import React from 'react';
export function CookiesPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-597">
      <div className="max-w-4xl mx-auto px-6" data-id="element-598">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-599">
          Política de Cookies
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-600">
          <p className="text-sm text-[#8b6f6f]" data-id="element-601">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-602">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-603">
              ¿Qué son las Cookies?
            </h2>
            <p data-id="element-604">
              Las cookies son pequeños archivos de texto que se almacenan en su
              dispositivo cuando visita un sitio web. Se utilizan ampliamente
              para hacer que los sitios web funcionen de manera más eficiente y
              proporcionar información a los propietarios del sitio.
            </p>
          </section>

          <section data-id="element-605">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-606">
              Tipos de Cookies que Utilizamos
            </h2>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-607">
              1. Cookies Esenciales
            </h3>
            <p data-id="element-608">
              Estas cookies son necesarias para que el sitio web funcione
              correctamente. Incluyen cookies que le permiten acceder a áreas
              seguras del sitio y realizar compras.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-609">
              <li data-id="element-610">Cookies de sesión</li>
              <li data-id="element-611">Cookies de seguridad</li>
              <li data-id="element-612">Cookies de carrito de compras</li>
            </ul>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-613">
              2. Cookies de Rendimiento
            </h3>
            <p data-id="element-614">
              Estas cookies recopilan información sobre cómo los visitantes
              utilizan el sitio web, como qué páginas visitan con más
              frecuencia. Esta información se utiliza para mejorar el
              funcionamiento del sitio.
            </p>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-615">
              3. Cookies de Funcionalidad
            </h3>
            <p data-id="element-616">
              Estas cookies permiten que el sitio web recuerde las elecciones
              que hace (como su idioma o región) y proporcionen características
              mejoradas y más personales.
            </p>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-617">
              4. Cookies de Marketing
            </h3>
            <p data-id="element-618">
              Estas cookies se utilizan para rastrear a los visitantes en los
              sitios web. La intención es mostrar anuncios que sean relevantes y
              atractivos para el usuario individual.
            </p>
          </section>

          <section data-id="element-619">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-620">
              Cookies de Terceros
            </h2>
            <p data-id="element-621">
              Utilizamos servicios de terceros que pueden establecer cookies en
              su dispositivo:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-622">
              <li data-id="element-623">
                <strong data-id="element-624">Hotmart:</strong> Para procesar pagos de forma segura
              </li>
              <li data-id="element-625">
                <strong data-id="element-626">Google Analytics:</strong> Para analizar el tráfico del
                sitio web
              </li>
              <li data-id="element-627">
                <strong data-id="element-628">Redes sociales:</strong> Si compartimos contenido en
                plataformas sociales
              </li>
            </ul>
          </section>

          <section data-id="element-629">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-630">
              Cómo Controlar las Cookies
            </h2>
            <p data-id="element-631">
              Puede controlar y/o eliminar las cookies como desee. Puede
              eliminar todas las cookies que ya están en su dispositivo y puede
              configurar la mayoría de los navegadores para evitar que se
              coloquen.
            </p>
            <p className="mt-4" data-id="element-632">
              <strong data-id="element-633">Configuración del navegador:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-634">
              <li data-id="element-635">
                <strong data-id="element-636">Chrome:</strong> Configuración → Privacidad y seguridad
                → Cookies
              </li>
              <li data-id="element-637">
                <strong data-id="element-638">Firefox:</strong> Opciones → Privacidad y seguridad →
                Cookies
              </li>
              <li data-id="element-639">
                <strong data-id="element-640">Safari:</strong> Preferencias → Privacidad → Cookies
              </li>
              <li data-id="element-641">
                <strong data-id="element-642">Edge:</strong> Configuración → Cookies y permisos del
                sitio
              </li>
            </ul>
            <p className="mt-4 text-sm italic" data-id="element-643">
              Nota: Si bloquea las cookies, algunas funciones del sitio web
              pueden no funcionar correctamente.
            </p>
          </section>

          <section data-id="element-644">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-645">
              Duración de las Cookies
            </h2>
            <p data-id="element-646">Las cookies que utilizamos tienen diferentes duraciones:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-647">
              <li data-id="element-648">
                <strong data-id="element-649">Cookies de sesión:</strong> Se eliminan cuando cierra su
                navegador
              </li>
              <li data-id="element-650">
                <strong data-id="element-651">Cookies persistentes:</strong> Permanecen en su
                dispositivo durante un período específico o hasta que las
                elimine manualmente
              </li>
            </ul>
          </section>

          <section data-id="element-652">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-653">
              Actualizaciones de esta Política
            </h2>
            <p data-id="element-654">
              Podemos actualizar esta Política de Cookies periódicamente para
              reflejar cambios en las cookies que utilizamos o por otras razones
              operativas, legales o reglamentarias.
            </p>
          </section>

          <section data-id="element-655">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-656">
              Más Información
            </h2>
            <p data-id="element-657">
              Si tiene preguntas sobre nuestra Política de Cookies, puede
              contactarnos a través de nuestro correo electrónico de soporte.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30 flex gap-6" data-id="element-658">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-659">
            ← Volver a la página principal
          </a>
          <button onClick={() => {
          // This would trigger a cookie consent modal in a real implementation
          alert('Configuración de cookies: Esta funcionalidad se implementaría con un banner de consentimiento de cookies.');
        }} className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-660">
            Configurar cookies
          </button>
        </div>
      </div>
    </div>;
}